import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import Summary from './Summary';
import Stakeholders from './Stakeholders';
import Engagement from './Engagement';
import Partners from './Partners';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <Box sx={{ p: 1 }}>{children}</Box>
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Index(props) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label='basic tabs example'
          variant='scrollable'
          scrollButtons='auto'
        >
          <Tab label='Summary' {...a11yProps(0)} />
          <Tab label='Engagement' {...a11yProps(1)} />
          <Tab label='Stakeholders' {...a11yProps(2)} />
          <Tab label='Partners' {...a11yProps(3)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Summary data={props.adminData.data} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Engagement data={props.adminData.data} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Stakeholders data={props.adminData.data} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Partners />
      </TabPanel>
    </Box>
  );
}
